import type { HTMLAttributes } from "react";
import { cx } from "../../lib/cx";
import styles from "./Logo.module.css";

export type LogoVariant = "full" | "mark" | "wordmark";

export type LogoProps = {
  variant?: LogoVariant;
} & HTMLAttributes<HTMLSpanElement>;

const FULL_SRC = "/icons/shobdo-high-resolution-logo-transparent.png";
const MARK_SRC = "/icons/shobdo-favicon-transparent.svg";

export const Logo = ({ variant = "full", className, ...rest }: LogoProps) => {
  const isMark = variant === "mark";
  return (
    <span aria-label="Shobdo" className={cx(styles.logo, className)} {...rest}>
      <img
        src={isMark ? MARK_SRC : FULL_SRC}
        alt="Shobdo"
        width={isMark ? 40 : 141}
        height={isMark ? 40 : 50}
        className={styles.image}
      />
    </span>
  );
};
